import React from 'react';

import { ReactProps } from '../../../typings/common-types';

import Icon, { IIcon } from './icon';

const svg = (props: ReactProps) => (
  <svg viewBox="0 0 132 132" version="1.1" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g fill="currentColor">
      <path d="M49.5 110H11V32.99h110V55h11V11c0-6.048-4.952-11-11-11H11C4.953 0 0 4.952 0 11v99c0 6.047 4.952 11 11 11h38.5v-11zM11 11h110v11H11V11z" />
      <path d="M128 71.769l-7.778-7.767-8.122 8.112a32.608 32.608 0 00-10.849-5.028V55h-16.5v12.086C70.522 70.75 60 83.627 60 99c0 18.231 14.77 33 33 33s33.002-14.769 33.002-33c0-7.131-2.284-13.706-6.124-19.11L128 71.77zM93 121c-12.148 0-22-9.852-22-22 0-12.15 9.852-22 22-22 12.15 0 22 9.85 22 22 0 12.148-9.85 22-22 22z" />
      <path d="M89.596 94.702a5.446 5.446 0 000 7.702 5.446 5.446 0 007.702 0L105 87l-15.404 7.702z" />
    </g>
  </svg>
);

const IconMotorDashboardCalendar = (props: IIcon & ReactProps) => <Icon {...props} svg={svg} />;

export default IconMotorDashboardCalendar;
